import ImdtLogin from '@/pages/user/imdtLogin';
import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Home from '../pages/home';
import Login from '../pages/user/login';

// 懒加载页面
const DataBase = lazy(() => import('@/pages/dataBase'));
const MdtStatistics = lazy(() => import('@/pages/mdtStatistics'));
const Lecture = lazy(() => import('@/pages/speechLecture/lecture'));
const Preview = lazy(() => import('@/pages/speechLecture/preview'));
const UserProtocol = lazy(() => import('../pages/user/login/userProtocol'));
const NoFind = lazy(() => import('../pages/user/noFind'));
const PersonalCenter = lazy(() => import('../pages/user/personalCenter'));

// 懒加载只能针对挂载在Home组件下的组件，因为Suspense组件放在Home中
const Index = lazy(() => import('../pages/index'));
const ElectronicEditor = lazy(() => import('../pages/patient/electronicEditor'));
const PersonalUserInfo = lazy(() => import('../pages/personal/usercenter'));
const IndexPatientDetail = lazy(() => import('../pages/index/patientDetail'));
const PatientList = lazy(() => import('../pages/patient/list'));
const PatientInviteCode = lazy(() => import('../pages/patient/patientInviteCode'));
const PatientDetail = lazy(() => import('../pages/patient/detail'));
const PatientDetailPage = lazy(() => import('../pages/patient/patientDetail'));
const PatientDetailForm = lazy(() => import('../pages/patient/patientDetailForm'));
const PatientSummary = lazy(() => import('../pages/patient/patientSummary'));
const PatientOcrImage = lazy(() => import('../pages/patient/patientOcrImage'));
const PatientInfoDetail = lazy(() => import('../pages/patient/patientInfoDetail'));
const IMDTAgent = lazy(() => import('../pages/patient/imdtAgent'));
/* ----- MDT团队 ------- */
const MdtTeam = lazy(() => import('../pages/mdtTeam'));
const MdtDetail = lazy(() => import('../pages/mdtTeam/mdtDetail'));
// 讲稿中心
const LectureCenter = lazy(() => import('../pages/lectureCenter/index'));
const OutlineMedicalHistory = lazy(() => import('../pages/lectureCenter/outlineMedicalHistory'));
/* ----- 会诊中心 ------- */
const ConsultationCenter = lazy(() => import('../pages/consultationCenter'));
const ConsultationDetail = lazy(() => import('../pages/consultationCenter/detail'));
const MeetingDetail = lazy(() => import('../pages/consultationCenter/meetingDetail'));
const ConsultationCreate = lazy(() => import('../pages/consultationCenter/createMeetForm'));
const ConsultationOldCreate = lazy(() => import('../pages/consultationCenter/create'));
const MeetingMinutesEdit = lazy(() => import('../pages/consultationCenter/editMeetingMinutes'));
const MeetingMinutesForm = lazy(() => import('../pages/consultationCenter/meetingMinutesForm'));
const IssueVoteDetail = lazy(() => import('../pages/consultationCenter/issueVoteDetail'));
const PictureTextMeeting = lazy(() => import('../pages/consultationCenter/pictureTextMeeting'));
/* ----- 病例库 ------- */
const CaseHistory = lazy(() => import('../pages/caseHistory'));
const ShareCaseHistory = lazy(() => import('../pages/caseHistory/share'));
const CombinedCaseHistory = lazy(() => import('../pages/caseHistory/case'));
const ConsultatDetail = lazy(() => import('../pages/caseHistory/consultatDetail'));
/* ----- 会诊讲稿 ------- */
const SpeechLecture = lazy(() => import('../pages/speechLecture'));
const Making = lazy(() => import('../pages/speechLecture/making'));
/* ----- 合同 ------- */
const ContractVerifica = lazy(() => import('../pages/contract/verification'));
const ContractTemplate = lazy(() => import('../pages/contract/template'));
const ContractPreview = lazy(() => import('../pages/contract/preview'));
// const FieldsConfig = lazy(() => import('../pages/contract/fieldsConfig'));
// const FieldsFormEditor = lazy(() => import('../pages/contract/fieldsFormEditor'));

// 系统管理
const AccountNumber = lazy(() => import('../pages/sysAdmin/accountNumber'));
const RoleAdmin = lazy(() => import('../pages/sysAdmin/roleAdmin'));
const MenuAdmin = lazy(() => import('../pages/sysAdmin/menuAdmin'));
const GroupAdmin = lazy(() => import('../pages/sysAdmin/groupAdmin'));
const DiseaseTypeAdmin = lazy(() => import('../pages/sysAdmin/diseaseTypeAdmin'));
// 主数据管理
const LabelAdmin = lazy(() => import('../pages/masterDataManagement/labelAdmin'));
const RegionAdmin = lazy(() => import('../pages/masterDataManagement/regionAdmin'));
const HospitalAdmin = lazy(() => import('../pages/masterDataManagement/hospitalAdmin'));
const DepartmentAdmin = lazy(() => import('../pages/masterDataManagement/departmentAdmin'));
const JobTitleAdmin = lazy(() => import('../pages/masterDataManagement/jobTitleAdmin'));
const BIConfiguration = lazy(() => import('../pages/bIModule/bIConfiguration'));
// 申请管理
const ConsultationApply = lazy(() => import('../pages/applyAdmin/consultationApply'));
const CooperationApply = lazy(() => import('../pages/applyAdmin/cooperationApply'));
// 机构管理
const OrganizationalList = lazy(
  () => import('../pages/organizationalManagement/organizational/list'),
);
const OrganizationalEdit = lazy(
  () => import('../pages/organizationalManagement/organizational/edit'),
);
const ProjectList = lazy(() => import('../pages/organizationalManagement/project/list'));
const OrganizationalProjectList = lazy(
  () => import('../pages/organizationalManagement/project/organizationalProjectList'),
);
const ProjectEdit = lazy(() => import('../pages/organizationalManagement/project/edit'));

// 医生管理
const DoctorList = lazy(() => import('../pages/doctor/list'));
const DoctorDetail = lazy(() => import('../pages/doctor/detail'));
const DoctorPatientList = lazy(() => import('../pages/doctor/doctorPatient'));
const DoctorInfoList = lazy(() => import('../pages/doctor/infoList'));
const DoctorInfoDetail = lazy(() => import('../pages/doctor/infoDetail'));
const DoctorEdit = lazy(() => import('../pages/doctor/edit'));
const DoctorUser = lazy(() => import('../pages/doctor/doctorUser'));
const CreateDoctor = lazy(() => import('../pages/doctor/createDoctor'));
const DoctorUserDetail = lazy(() => import('../pages/doctor/doctorUser/doctorUserDetail'));
const RegiStatistics = lazy(() => import('../pages/doctor/doctorUser/regiStatistics'));

// 医助管理
const DoctorAssistantList = lazy(() => import('../pages/doctorAssistant/list'));
const DoctorAssistantDetail = lazy(() => import('../pages/doctorAssistant/detail'));

// 公众号管理
const OfficialList = lazy(() => import('../pages/officialAccount/officialList'));
const AllianceDetails = lazy(() => import('../pages/officialAccount/allianceDetails'));
const EditorialAlliance = lazy(() => import('../pages/officialAccount/editorialAlliance'));
const CreateTeam = lazy(() => import('../pages/officialAccount/createTeam'));
const CreateActivity = lazy(() => import('../pages/officialAccount/createActivity'));

// MDT评分
const Scorelist = lazy(() => import('../pages/score/scorelist'));
const ScoreDetails = lazy(() => import('../pages/score/scoreDetails'));
// 订单管理
const OrderList = lazy(() => import('../pages/orderAdmin/orderLIst'));
const OrderDetails = lazy(() => import('../pages/orderAdmin/orderDetails'));
// 交易流水
const TransactionList = lazy(() => import('../pages/transactionFlow/transactionList'));

// 招募管理页
const RecruitmentManage = lazy(() => import('../pages/consultationRecruitment/recruitmentManage'));
const RecruitmentManageDetail = lazy(
  () => import('../pages/consultationRecruitment/recruitmentManageDetail'),
);
const SignUp = lazy(() => import('../pages/consultationRecruitment/signUp'));
const Recruitment = lazy(() => import('../pages/consultationRecruitment/recruitment'));
const RecruitmentDetails = lazy(
  () => import('../pages/consultationRecruitment/recruitment/detail'),
);

// 表单库
const FormilyList = lazy(() => import('../pages/formily/list'));
const FormilyEditor = lazy(() => import('../pages/formily/editor'));

// 随访管理
const FollowList = lazy(() => import('../pages/followUp/list'));
const FollowDetail = lazy(() => import('../pages/followUp/detail'));

const QualityControlScore = lazy(() => import('../pages/qualityControlScore/list'));
const QualityControlScoreDetail = lazy(() => import('../pages/qualityControlScore/detail'));

const SettledApplyList = lazy(() => import('../pages/settledApply/list'));

// 活动管理
const ActivityManage = lazy(() => import('../pages/activity/activityManage'));
const ActivityEdit = lazy(() => import('../pages/activity/activityEdit'));
const ActivityUserManage = lazy(() => import('../pages/activity/activityUserManage'));
const ActivityUserDetail = lazy(() => import('../pages/activity/activityUserDetail'));
const ActivitySubjectManage = lazy(() => import('../pages/activity/activitySubjectManage'));
const ActivityStatistics = lazy(() => import('../pages/activity/activityStatistics'));
const ActivityStatisticsDetail = lazy(() => import('../pages/activity/activityStatisticsDetail'));
const ActivityOperationalAnalysis = lazy(
  () => import('../pages/activity/activityOperationalAnalysis'),
);

// 联合病房-相关路由配置
const CombinedWardMdt = lazy(() => import('../pages/combinedWard/mdt'));
const CombinedWardMdtDetail = lazy(() => import('../pages/combinedWard/mdtDetail'));
const CombinedWardImChat = lazy(() => import('../pages/combinedWard/imChat'));
const CombinedWardMdtConsult = lazy(() => import('../pages/combinedWard/mdtConsult'));
const CombinedWardMdtConsultCreate = lazy(() => import('../pages/combinedWard/mdtConsultCreate'));
const CombinedWardMdtConsultDetail = lazy(() => import('../pages/combinedWard/mdtConsultDetail'));
const CombinedWardScoreResults = lazy(() => import('../pages/combinedWard/scoreResults'));
const CombinedWardScoreDetail = lazy(() => import('../pages/combinedWard/qualityScoreDetail'));
const CombinedWardTimelineLecture = lazy(() => import('../pages/combinedWard/timelineLecture'));
const CombinedWardPatientCaseTag = lazy(() => import('../pages/combinedWard/patientCaseTag'));
const CombinedWardCaseRecordsComments = lazy(
  () => import('../pages/combinedWard/caseRecordsComments'),
);
const CombinedWardPicSmaller = lazy(() => import('../pages/combinedWard/picSmaller'));
const CombinedImageRecognite = lazy(() => import('../pages/combinedWard/imageRecognite'));
const CombinedRecogniteDetail = lazy(
  () => import('../pages/combinedWard/imageRecognite/recogniteDetail'),
);
const CombinedPptEditor = lazy(() => import('../pages/combinedWard/pptEditor'));
const MpleMindMap = lazy(() => import('../pages/combinedWard/mpleMindMap'));
const RegistrationApplication = lazy(() => import('../pages/combinedWard/registrationApplication'));
const ExportBasicInfo = lazy(() => import('../pages/combinedWard/exportBasicInfo'));
const PlatformLiveReplay = lazy(() => import('../pages/combinedWard/platformLiveReplay'));

// 多渠道管理 - 注册渠道
const DoctorRegistrChannel = lazy(
  () => import('../pages/pspPackage/registerManagement/doctorRegistrChannel'),
);
// 患者管理 - 患者注册场景
const PatientRegistrScene = lazy(
  () => import('../pages/pspPackage/registerManagement/patientRegistrScene'),
);
// 患者管理 - 注册场景表单
const RegistrSceneForm = lazy(
  () => import('../pages/pspPackage/registerManagement/registrSceneForm'),
);
// 用户管理 - 患者用户管理
const PatientUserManagement = lazy(
  () => import('../pages/pspPackage/userManagement/patientUserManagement'),
);
// 用户管理 - 医生用户管理
const DoctorUserManagement = lazy(
  () => import('../pages/pspPackage/userManagement/doctorUserManagement'),
);
// 用户管理 - 医生用户详情
const DoctorUserManagementDetail = lazy(
  () => import('../pages/pspPackage/userManagement/doctorUserDetail'),
);
// 首页面板
const HomePanel = lazy(() => import('../pages/pspPackage/homePanel'));
// 工作台面板
const WorkbenchPanel = lazy(() => import('../pages/pspPackage/workbenchPanel'));
// 患者病历管理
const PatientMedicalRecord = lazy(
  () => import('../pages/pspPackage/medicalRecordManagement/patientMedicalRecord'),
);
// 图片收集箱
const PhotoCollectionBox = lazy(
  () => import('../pages/pspPackage/medicalRecordManagement/photoCollectionBox'),
);
// 患者病历详情
const PatientMedicalDetail = lazy(
  () => import('../pages/pspPackage/medicalRecordManagement/patientMedicalDetail'),
);

// 项目管理
const ProjectManagement = lazy(
  () => import('../pages/pspPackage/experManagement/projectManagement'),
);
// 档案管理 - 档案表单管理
const FileFormManagement = lazy(
  () => import('../pages/pspPackage/experManagement/fileFormManagement'),
);
// 档案管理 - 档案表单编辑
const FileFormEditor = lazy(
  () => import('../pages/pspPackage/experManagement/fileFormEditor/index'),
);
// 工作流聊天
const WorkflowChat = lazy(() => import('../pages/pspPackage/sessionManagement/workflowChat'));
const ChatLog = lazy(() => import('../pages/pspPackage/sessionManagement/chatLog'));
const QualityControlScoreNew = lazy(
  () => import('../pages/pspPackage/qualityControlManagement/qualityControlScore'),
);
const QualityScoreForm = lazy(
  () => import('../pages/pspPackage/qualityControlManagement/qualityScoreForm'),
);
const QualityControlList = lazy(
  () => import('../pages/pspPackage/qualityControlManagement/qualityControlList'),
);
const QualityControlDetail = lazy(
  () => import('../pages/pspPackage/qualityControlManagement/qualityControlDetail'),
);
const MedicalRecordQuality = lazy(
  () => import('../pages/pspPackage/qualityControlManagement/medicalRecordQuality'),
);
const QualityControlOverview = lazy(
  () => import('../pages/pspPackage/qualityControlManagement/qualityControlOverview'),
);
const QualityControlDashboard = lazy(
  () => import('../pages/pspPackage/qualityControlManagement/qualityControlDashboard'),
);

export type routerConfigItem = {
  path: string;
  name?: string;
  code?: string;
  element?: React.ReactNode;
  hideInMenu?: boolean;
  children?: routerConfigItem[];
  meta?: {
    parent?: string; // 父级路由路径，用于生成面包屑
    back?: boolean; // 点击面包屑时是否使用返回而非跳转
  };
  cached?: boolean; // 是否需要缓存
};

export const baseRouterConfig = [
  {
    path: '/login',
    element: <ImdtLogin />,
  },
  {
    path: '/imdt-login',
    element: <Login />,
  },
  {
    path: '/login/user-protocol',
    element: <UserProtocol />,
  },
  {
    path: '*',
    element: <NoFind />,
  },
];
const routerConfig: routerConfigItem[] = [
  {
    path: '/',
    element: <Home />,
    children: [
      {
        path: '/',
        element: <Navigate to="/index" replace />,
      },
      {
        path: '/patient/imdtAgent',
        name: 'IMDT病历智能体',
        element: <Index />,
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/patient/electronicEditor',
        name: '电子病历编辑器',
        element: <ElectronicEditor />,
        meta: { parent: '/index' },
      },
      {
        path: '/index',
        name: '首页',
        // element: <IMDTAgent />,
        element: <WorkbenchPanel />,
        cached: true,
      },
      {
        path: '/index/patient-detail',
        name: '完善患者病例',
        element: <IndexPatientDetail />,
        code: 'IndexPatientDetail',
        meta: { parent: '/index' },
      },
      {
        path: '/personal/userinfo',
        name: '个人中心',
        element: <PersonalUserInfo />,
        meta: { parent: '/index' },
      },
      {
        path: '/personal-center/index',
        name: '个人中心',
        element: <PersonalCenter />,
        code: 'PersonalCenter',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/patient/patientInviteCode',
        name: '授权邀请码',
        element: <PatientInviteCode />,
        code: 'patientInviteCode',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/patient/list',
        name: '患者病历',
        element: <PatientMedicalRecord />,
        code: 'PatientManageList',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/patient/detail',
        name: '患者详情',
        element: <PatientMedicalDetail />,
        // element: <PatientDetailPage />,
        meta: { parent: '/patient/list' },
      },
      {
        path: '/patient/patientDetail',
        name: '患者详情',
        element: <PatientDetail />,
        meta: { parent: '/patient/list' },
      },
      {
        path: '/patient/patientDetailForm',
        name: '新增记录',
        element: <PatientDetailForm />,
        meta: { parent: '/patient/patientDetail', back: true },
      },
      {
        path: '/patient/detail/patientCaseTag',
        name: '编辑标签',
        element: <CombinedWardPatientCaseTag />,
        meta: { parent: '/patient/detail', back: true },
      },
      {
        path: '/patient/detail/patientSummary',
        name: '编辑病史摘要',
        element: <PatientSummary />,
        meta: { parent: '/patient/detail', back: true },
      },
      {
        path: '/patient/detail/patientInfoDetail',
        name: '患者信息详情',
        element: <PatientInfoDetail disabled />,
        meta: { parent: '/patient/detail', back: true },
      },
      {
        path: '/patient/detail/patientInfoEdit',
        name: '患者信息编辑',
        element: <PatientInfoDetail />,
        meta: { parent: '/patient/detail', back: true },
      },
      {
        path: '/patient/detail/patientOcr',
        name: '患者OCR',
        element: <PatientOcrImage />,
        meta: { parent: '/patient/detail', back: true },
      },
      {
        path: '/lecture-center/index',
        name: '讲稿中心',
        element: <LectureCenter />,
        code: 'LectureCenterList',
        cached: true,
        meta: { parent: '/index' },
      },
      // mdt团队
      {
        path: '/mdt-team/index',
        name: 'MDT团队',
        element: <MdtTeam />,
        code: 'MdtTeam',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/mdt-team/detail',
        name: '团队详情',
        element: <MdtDetail />,
        code: 'MdtDetail',
        meta: { parent: '/mdt-team/index' },
      },
      // 会诊中心
      {
        path: '/consultation-center/index',
        name: 'MDT会诊',
        element: <ConsultationCenter />,
        code: 'ConsultationCenterList',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/consultation-center/detail',
        name: '会诊详情',
        element: <MeetingDetail />,
        code: 'ConsultationDetail',
        meta: { parent: '/consultation-center/index' },
      },
      {
        path: '/consultation-center/meetingDetail',
        name: '会诊详情',
        element: <ConsultationDetail />,
        code: 'ConsultationDetail',
        meta: { parent: '/consultation-center/index' },
      },
      {
        path: '/consultation-center/create',
        name: '创建会诊',
        element: <ConsultationCreate />,
        code: 'ConsultationCreate',
        meta: { parent: '/consultation-center/index' },
      },
      {
        path: '/consultation-center/oldCreate',
        name: '创建会诊',
        element: <ConsultationOldCreate />,
        code: 'ConsultationCreate',
        meta: { parent: '/consultation-center/index' },
      },
      {
        path: '/consultation-center/editMeetingMinutes',
        name: '编辑会诊纪要',
        element: <MeetingMinutesEdit />,
        code: 'MeetingMinutesEdit',
        meta: { parent: '/consultation-center/index' },
      },
      {
        path: '/consultation-center/meetingMinutesForm',
        name: '编辑会诊纪要',
        element: <MeetingMinutesForm />,
        code: 'MeetingMinutesForm',
        meta: { parent: '/consultation-center/index' },
      },
      {
        path: '/consultation-center/issueVoteDetail',
        name: '投票详情',
        element: <IssueVoteDetail />,
        code: 'IssueVoteDetail',
        meta: { parent: '/consultation-center/index' },
      },

      /* ----- 病例库 ------- */
      {
        path: '/case-history/index',
        name: '病例列表',
        element: <CaseHistory />,
        code: 'CaseHistoryList',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/case-history/case',
        name: '项目病例库',
        element: <CombinedCaseHistory />,
        code: 'CombinedCaseBank',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/case-history/share',
        name: '共享病例库',
        element: <ShareCaseHistory />,
        code: 'ShareCaseHistoryList',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/combinedWard/exportBasicInfo',
        name: '基本信息导出',
        element: <ExportBasicInfo />,
        code: 'exportBasicInfo',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/case-history/consultat-detail',
        name: '会诊详情',
        element: <ConsultatDetail />,
        code: 'ShareCaseConsultatDetail',
        meta: { parent: '/case-history/share' },
      },
      /* ----- 会诊讲稿 ------- */
      {
        path: '/speech-lecture/index',
        name: '会诊讲稿',
        element: <SpeechLecture />,
        code: 'SpeechLectureList',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/speech-lecture/making',
        name: '制作讲稿',
        element: <Making />,
        code: 'SpeechMakingList',
        meta: { parent: '/speech-lecture/index' },
      },
      /* ----- 合同 ------- */
      {
        path: '/contract/verification',
        name: '审核列表',
        element: <ContractVerifica />,
        code: 'ContractVerificaList',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/contract/template',
        name: '合同模板',
        element: <ContractTemplate />,
        code: 'ContractTemplateList',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/contract/preview',
        name: '合同预览',
        element: <ContractPreview />,
        code: 'ContractPreview',
        meta: { parent: '/contract/verification' },
      },
      // {
      //   path: '/contract/fields',
      //   name: '合同字段表',
      //   element: <FieldsConfig />,
      //   code: 'FieldsConfig',
      // },
      // {
      //   path: '/contract/fieldsForm',
      //   name: '编辑字段',
      //   element: <FieldsFormEditor />,
      // },
      {
        path: '/sys/accountNumber',
        name: '账号管理',
        element: <AccountNumber />,
        code: 'AccountNumber',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/sys/roleAdmin',
        name: '角色管理',
        element: <RoleAdmin />,
        code: 'RoleAdmin',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/sys/menuAdmin',
        name: '菜单管理',
        element: <MenuAdmin />,
        code: 'MenuAdmin',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/sys/groupAdmin',
        name: '权限组管理',
        element: <GroupAdmin />,
        code: 'GroupAdmin',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/sys/diseaseTypeAdmin',
        name: '病种管理',
        element: <DiseaseTypeAdmin />,
        code: 'DiseaseTypeAdmin',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/masterDataManagement',
        name: '主数据管理',
        code: 'MasterDataManagement',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/masterDataManagement/labelAdmin',
        name: '系统标签管理',
        element: <LabelAdmin />,
        code: 'LabelAdmin',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/masterDataManagement/regionAdmin',
        name: '区域管理',
        element: <RegionAdmin />,
        code: 'RegionAdmin',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/masterDataManagement/hospitalAdmin',
        name: '医院管理',
        element: <HospitalAdmin />,
        code: 'HospitalAdmin',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/masterDataManagement/departmentAdmin',
        name: '科室管理',
        element: <DepartmentAdmin />,
        code: 'DepartmentAdmin',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/masterDataManagement/jobTitleAdmin',
        name: '职称管理',
        element: <JobTitleAdmin />,
        code: 'JobTitleAdmin',
        cached: true,
        meta: { parent: '/index' },
      },

      {
        path: '/bIModule/bIConfiguration',
        name: 'BI配置',
        element: <BIConfiguration />,
        code: 'BIConfiguration',
        cached: true,
        meta: { parent: '/index' },
      },

      {
        path: '/applyAdmin/consultationApply',
        name: '会诊申请',
        element: <ConsultationApply />,
        code: 'ConsultationApply',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/applyAdmin/cooperationApply',
        name: '合作申请',
        element: <CooperationApply />,
        code: 'CooperationApply',
        cached: true,
        meta: { parent: '/index' },
      },
      // {
      //   path: '/organizationalManagement/institutionAdmin',
      //   name: '机构管理',
      //   element: <InstitutionAdmin />,
      //   code: 'InstitutionAdmin',
      // },
      // {
      //   path: '/organizationalManagement/institutionalDetails',
      //   name: '机构详情',
      //   element: <InstitutionalDetails />,
      //   code: 'InstitutionalDetails',
      // },
      {
        path: '/organizational',
        name: '机构信息',
        element: <OrganizationalList />,
        code: 'OrganizationalList',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/organizational/edit',
        name: '编辑机构信息',
        element: <OrganizationalEdit />,
        meta: { parent: '/organizational' },
      },
      {
        path: '/project',
        name: '项目信息',
        element: <ProjectList />,
        code: 'ProjectList',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/organizational/project',
        name: '项目信息',
        element: <OrganizationalProjectList />,
        code: 'OrgProjectList',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/project/edit',
        name: '编辑项目信息',
        element: <ProjectEdit />,
        meta: { parent: '/project' },
      },

      {
        path: '/officialAccount/officialList',
        name: '公众号网站管理',
        element: <OfficialList />,
        code: 'OfficialList',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/doctor/list',
        name: '医生管理',
        element: <DoctorList />,
        code: 'DoctorList',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/doctor/user',
        name: '医生用户管理',
        element: <DoctorUser />,
        code: 'DoctorUser',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/doctor/user/regiStatistics',
        name: '注册数据统计',
        element: <RegiStatistics />,
        code: 'DoctorUserStatistic',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/doctor/user/detail',
        name: '医生用户详情',
        element: <DoctorUserDetail />,
        meta: { parent: '/doctor/user' },
      },
      {
        path: '/doctor/edit',
        name: '创建医生',
        element: <DoctorEdit />,
        meta: { parent: '/doctor/list' },
      },
      {
        path: '/doctor/create',
        name: '创建医生',
        element: <CreateDoctor />,
        meta: { parent: '/doctor/list' },
      },
      {
        path: '/officialAccount/allianceDetails',
        name: '联盟详情',
        element: <AllianceDetails />,
        code: 'AllianceDetailsNew',
        hideInMenu: true,
        meta: { parent: '/officialAccount/officialList' },
      },
      {
        path: '/officialAccount/editorialAlliance',
        name: '编辑联盟',
        element: <EditorialAlliance />,
        code: 'EditorialAlliance',
        hideInMenu: true,
        meta: { parent: '/officialAccount/officialList' },
      },
      {
        path: '/officialAccount/createTeam',
        name: '创建联盟',
        element: <CreateTeam />,
        code: 'CreateTeam',
        hideInMenu: true,
        meta: { parent: '/officialAccount/officialList' },
      },
      {
        path: '/officialAccount/createActivity',
        name: '创建活动',
        element: <CreateActivity />,
        code: 'CreateActivity',
        hideInMenu: true,
        meta: { parent: '/officialAccount/officialList' },
      },
      {
        path: '/doctor/detail',
        name: 'MDT详情',
        element: <DoctorDetail />,
        meta: { parent: '/doctor/list' },
      },
      {
        path: '/doctor/doctorPatient',
        name: '病例列表',
        element: <DoctorPatientList />,
        meta: { parent: '/doctor/list' },
      },
      {
        path: '/doctor/info/list',
        name: '医生信息库',
        element: <DoctorInfoList />,
        code: 'DoctorInfoList',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/doctor/info/detail',
        name: '医生详情',
        element: <DoctorInfoDetail />,
        code: 'DoctorInfoList',
        meta: { parent: '/doctor/info/list' },
      },
      {
        path: '/doctor/assistant/list',
        name: '医助管理',
        element: <DoctorAssistantList />,
        code: 'DoctorAssistantList',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/doctor/assistant/detail',
        name: '医助详情',
        element: <DoctorAssistantDetail />,
        meta: { parent: '/doctor/assistant/list' },
      },
      {
        path: '/scoreModule/scorelist',
        name: 'MDT评价',
        element: <Scorelist />,
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/scoreModule/scoreDetails',
        name: '评分详情',
        element: <ScoreDetails />,
        meta: { parent: '/scoreModule/scorelist' },
      },

      {
        path: '/orderAdmin/orderList',
        name: '订单管理',
        element: <OrderList />,
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/orderAdmin/orderDetails',
        name: '订单详情',
        element: <OrderDetails />,
        meta: { parent: '/orderAdmin/orderList' },
      },
      {
        path: '/transactionFlow/transactionList',
        name: '交易流水',
        element: <TransactionList />,
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/consultationRecruitment/recruitmentManage',
        name: '招募管理',
        element: <RecruitmentManage />,
        code: 'RecruitmentManage',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/consultationRecruitment/recruitmentManageDetail',
        name: '招募详情',
        element: <RecruitmentManageDetail />,
        meta: { parent: '/consultationRecruitment/recruitmentManage' },
      },
      {
        path: '/consultationRecruitment/signUp',
        name: '报名管理',
        element: <SignUp />,
        code: 'RecruitmentRegister',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/consultationRecruitment/recruitment',
        name: '招募列表',
        element: <Recruitment />,
        code: 'RecruitmentDoctor',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/consultationRecruitment/recruitmentDetails',
        name: '招募详情',
        element: <RecruitmentDetails />,
        meta: { parent: '/consultationRecruitment/recruitment' },
      },
      {
        path: '/formily/list',
        name: '表单库',
        element: <FormilyList />,
        code: 'FormilyList',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/formily/editor',
        name: '表单编辑',
        element: <FormilyEditor />,
        meta: { parent: '/formily/list' },
      },
      {
        path: '/followUp/list',
        name: '随访管理',
        element: <FollowList />,
        code: 'FollowUpList',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/followUp/detail',
        name: '随访详情',
        element: <FollowDetail />,
        meta: { parent: '/followUp/list' },
      },
      {
        path: '/qualityControlScore/list',
        name: '质控评分管理',
        element: <QualityControlScore />,
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/qualityControlScore/detail',
        name: '质控评分详情',
        element: <QualityControlScoreDetail />,
        meta: { parent: '/qualityControlScore/list' },
      },
      {
        path: '/settledApply/list',
        name: '入驻申请',
        element: <SettledApplyList />,
        code: 'SettledApplyList',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/activity/list',
        name: '活动管理',
        element: <ActivityManage />,
        code: 'ActivityManage',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/activity/add',
        name: '新增活动',
        element: <ActivityEdit />,
        meta: { parent: '/activity/list' },
      },
      {
        path: '/activity/edit',
        name: '活动编辑',
        element: <ActivityEdit />,
        meta: { parent: '/activity/list' },
      },
      {
        path: '/activity/user',
        name: '活动用户管理',
        element: <ActivityUserManage />,
        code: 'ActivityUserManage',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/activity/user/detail',
        name: '统计详情',
        element: <ActivityUserDetail />,
        code: 'ActivityUserDetail',
        meta: { parent: '/activity/user' },
      },
      {
        path: '/activity/subject',
        name: '活动专题管理',
        element: <ActivitySubjectManage />,
        code: 'ActivitySubjectManag',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/activity/statistics',
        name: '活动数据列表',
        element: <ActivityStatistics />,
        code: 'AcStatisticManage',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/activity/statistics/detail',
        name: '统计详情',
        element: <ActivityStatisticsDetail />,
        meta: { parent: '/activity/statistics' },
      },
      {
        path: '/activity/operational',
        name: '活动运营分析',
        element: <ActivityOperationalAnalysis />,
        code: 'AcOperatorManage',
        meta: { parent: '/index' },
      },
      // 联合病房-相关路由配置
      {
        path: '/combinedWard/mdt',
        name: '联合病房MDT团队',
        element: <CombinedWardMdt />,
        code: 'CombinedWardMdt',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/combinedWard/mdtDetail',
        name: '团队详情',
        element: <CombinedWardMdtDetail />,
        code: 'CombinedWardMdtDetail',
        meta: { parent: '/combinedWard/mdt' },
      },
      {
        path: '/combinedWard/mdtConsult',
        name: '团队会诊中心',
        element: <CombinedWardMdtConsult />,
        code: 'CombinedWardMdtConsu',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/combinedWard/mdtConsultCreate',
        name: '创建会诊',
        element: <CombinedWardMdtConsultCreate />,
        code: 'CombinedWardMdtConsultCreate',
        meta: { parent: '/combinedWard/mdt' },
      },
      {
        path: '/combinedWard/mdtConsultDetail',
        name: '会诊详情',
        element: <CombinedWardMdtConsultDetail />,
        code: 'CombinedWardMdtConsultDetail',
        meta: { parent: '/combinedWard/mdtConsult' },
      },
      {
        path: '/combinedWard/scoreResults',
        name: '确认评分结果',
        element: <CombinedWardScoreResults />,
        code: 'CombinedWardScoreResults',
        meta: { parent: '/patient/list' },
      },
      {
        path: '/combinedWard/qualityScoreDetail',
        name: '质控参考评分详情',
        element: <CombinedWardScoreDetail />,
        code: 'CombinedWardScoreDetail',
        meta: { parent: '/patient/list' },
      },
      {
        path: '/combinedWard/timelineLecture',
        name: '编辑病例时间轴',
        element: <CombinedWardTimelineLecture />,
        code: 'CombinedWardTimelineLecture',
        meta: { parent: '/patient/list' },
      },
      {
        path: '/combinedWard/caseRecordsComments',
        name: '病例更新及点评记录',
        element: <CombinedWardCaseRecordsComments />,
        code: 'CaseRecordsComments',
        meta: { parent: '/combinedWard/mdtDetail', back: true },
      },
      {
        path: '/combinedWard/picSmaller',
        name: '图小小',
        element: <CombinedWardPicSmaller />,
        code: 'PicSmaller',
        meta: { parent: '/index' },
      },
      {
        path: '/combinedWard/imageRecognite',
        name: '图像识别管理',
        element: <CombinedImageRecognite />,
        code: 'ImageRecognition',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/combinedWard/recogniteDetail',
        name: '图像识别详情',
        element: <CombinedRecogniteDetail />,
        code: 'RecogniteDetail',
        meta: { parent: '/combinedWard/imageRecognite' },
      },
      {
        path: '/combinedWard/registrationApplication',
        name: '注册申请',
        element: <RegistrationApplication />,
        code: 'RegistApplicate',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/registerManagement/doctorRegistrChannel',
        name: '医生注册渠道配置',
        element: <DoctorRegistrChannel />,
        code: 'DoctorRegistrChannel',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/registerManagement/patientRegistrScene',
        name: '患者注册场景码配置',
        element: <PatientRegistrScene />,
        code: 'PatientRegistrScene',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/registerManagement/registrSceneForm',
        name: '编辑场景码配置',
        element: <RegistrSceneForm />,
        code: 'RegistrSceneForm',
        meta: { parent: '/index' },
      },
      {
        path: '/userManagement/patientUserManagement',
        name: '患者用户管理',
        element: <PatientUserManagement />,
        code: 'PatientUserManage',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/userManagement/doctorUserManagement',
        name: '医生用户管理',
        element: <DoctorUserManagement />,
        code: 'DoctorUserManage',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/userManagement/doctorUserDetail',
        name: '医生详情',
        element: <DoctorUserManagementDetail />,
        code: 'DoctorUserManagementDetail',
        meta: { parent: '/userManagement/doctorUserManagement' },
      },
      {
        path: '/userManagement/homePanel',
        name: '首页面板',
        element: <HomePanel />,
        code: 'HomePanel',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/userManagement/workbenchPanel',
        name: '工作台面板',
        element: <WorkbenchPanel />,
        code: 'HomePanel',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/medicalRecordManagement/photoCollectionBox',
        name: '图片收集箱',
        element: <PhotoCollectionBox />,
        code: 'PhotoCollectionBox',
        cached: true,
        meta: { parent: '/index' },
      },
      // {
      //   path: '/medicalRecordManagement/patientMedicalRecord',
      //   name: '患者病历',
      //   element: <PatientMedicalRecord />,
      //   code: 'PatientMedicalRecord',
      //   cached: true,
      //   meta: { parent: '/index' },
      // },
      // {
      //   path: '/medicalRecordManagement/patientMedicalDetail',
      //   name: '患者病历详情',
      //   element: <PatientMedicalDetail />,
      //   code: 'PatientMedicalDetail',
      //   meta: { parent: '/medicalRecordManagement/patientMedicalRecord' },
      // },
      {
        path: '/experManagement/projectManagement',
        name: '项目管理',
        element: <ProjectManagement />,
        code: 'ProjectManagement',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/experManagement/fileFormManagement',
        name: '建档表单管理',
        element: <FileFormManagement />,
        code: 'FileFormManagement',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/experManagement/fileFormEditor',
        name: '建档表单编辑',
        element: <FileFormEditor />,
        code: 'FileFormEditor',
        meta: { parent: '/experManagement/fileFormEditor' },
      },
      {
        path: '/sessionManagement/workflowChat',
        name: '聚合聊天',
        element: <WorkflowChat />,
        code: 'WorkflowChat',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/sessionManagement/chatLog',
        name: '聊天记录',
        element: <ChatLog />,
        code: 'ChatLog',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/qualityControl/score',
        name: '质控评分管理',
        element: <QualityControlScoreNew />,
        code: 'ControlQualityScore',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/qualityControl/qualityScoreForm',
        name: '质控评分详情',
        element: <QualityScoreForm />,
        code: 'QualityControlScore',
      },
      {
        path: '/qualityControl/qualityControlList',
        name: '质控列表', // 管理员
        element: <QualityControlList />,
        code: 'QalityControlList',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/qualityControl/qualityControlDetail',
        name: '质控详情',
        element: <QualityControlDetail />,
        code: 'QualityControlDetail',
        meta: { parent: '/index' },
      },
      {
        path: '/qualityControl/medicalRecordQuality',
        name: '病历质控管理', // 医生
        element: <MedicalRecordQuality />,
        code: 'MedicalRecordQuality',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/qualityControl/dashboard',
        name: '质控看板',
        element: <QualityControlDashboard />,
        code: 'QControlDashboard',
        cached: true,
        meta: { parent: '/index' },
      },
      {
        path: '/qualityControl/overview',
        name: '质控总览',
        element: <QualityControlOverview />,
        code: 'QControlOverview',
        cached: true,
        meta: { parent: '/index' },
      },
    ],
  },
  {
    path: '/combinedWard/pptEditor',
    name: '图片识别详情',
    element: <CombinedPptEditor />,
    code: 'RecogniteDetail',
    hideInMenu: true,
    meta: { parent: '/index' },
  },
  {
    path: '/combinedWard/mpleMindMap',
    name: 'MDT时间轴',
    element: <MpleMindMap />,
    code: 'MpleMindMap',
    hideInMenu: true,
    meta: { parent: '/index' },
  },
  {
    path: '/speech-lecture/preview',
    name: '讲稿预览',
    element: <Preview />,
    code: 'SpeechMakingList',
    hideInMenu: true,
    meta: { parent: '/speech-lecture/index' },
  },
  {
    path: '/combinedWard/imChat',
    name: '图文会诊',
    element: <CombinedWardImChat />,
    code: 'CombinedWardImChat',
    hideInMenu: true,
    meta: { parent: '/combinedWard/mdtConsult' },
  },
  {
    path: '/consultation-center/pictureTextMeeting',
    name: '图文会诊',
    element: <PictureTextMeeting />,
    code: 'PictureTextMeeting',
    hideInMenu: true,
    meta: { parent: '/consultation-center/index' },
  },
  {
    path: '/lecture-center/outline-medical-history',
    name: '病史大纲',
    element: <OutlineMedicalHistory />,
    code: 'OutlineMedicalHistory',
    hideInMenu: true,
    meta: { parent: '/lecture-center/index' },
  },
  {
    path: '/speech-lecture/lecture',
    name: '讲稿预览',
    element: <Lecture />,
    code: 'SpeechMakingList',
    hideInMenu: true,
    meta: { parent: '/speech-lecture/index' },
  },
  {
    path: '/dataBase',
    name: '数据统计',
    element: <DataBase />,
    code: 'DataBase',
    hideInMenu: true,
    meta: { parent: '/index' },
  },
  {
    path: '/mdt-statistics',
    name: 'MDT数据统计',
    element: <MdtStatistics />,
    code: 'MdtStatistics',
    hideInMenu: true,
    meta: { parent: '/index' },
  },
  {
    path: '/combinedWard/platformLiveReplay',
    name: '平台直播回放',
    element: <PlatformLiveReplay />,
    code: 'PlatformLiveReplay',
    meta: { parent: '/index' },
  },
  ...baseRouterConfig,
];

export default routerConfig;
